import { createTheme } from '@mui/material';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    h1Semibold?: React.CSSProperties;
    h1Bold?: React.CSSProperties;
    h2Semibold?: React.CSSProperties;
    h2Bold?: React.CSSProperties;
    h3Semibold?: React.CSSProperties;
    h3Bold?: React.CSSProperties;
    h4Semibold?: React.CSSProperties;
    h4Bold?: React.CSSProperties;
    h5Semibold?: React.CSSProperties;
    h5Bold?: React.CSSProperties;
    h6Semibold?: React.CSSProperties;
    h6Bold?: React.CSSProperties;
    h7?: React.CSSProperties;
    h7Semibold?: React.CSSProperties;
    h7Bold?: React.CSSProperties;
    h8?: React.CSSProperties;
    h8Semibold?: React.CSSProperties;
    h8Bold?: React.CSSProperties;
    h9?: React.CSSProperties;
    h9Semibold?: React.CSSProperties;
    h9Bold?: React.CSSProperties;
    h10?: React.CSSProperties;
    h10Semibold?: React.CSSProperties;
    h10Bold?: React.CSSProperties;
    h11?: React.CSSProperties;
    h11Semibold?: React.CSSProperties;
    h11Bold?: React.CSSProperties;
    h12?: React.CSSProperties;
    h12Semibold?: React.CSSProperties;
    h12Bold?: React.CSSProperties;
    h13?: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    h1Semibold?: React.CSSProperties;
    h1Bold?: React.CSSProperties;
    h2Semibold?: React.CSSProperties;
    h2Bold?: React.CSSProperties;
    h3Semibold?: React.CSSProperties;
    h3Bold?: React.CSSProperties;
    h4Semibold?: React.CSSProperties;
    h4Bold?: React.CSSProperties;
    h5Semibold?: React.CSSProperties;
    h5Bold?: React.CSSProperties;
    h6Semibold?: React.CSSProperties;
    h6Bold?: React.CSSProperties;
    h7?: React.CSSProperties;
    h7Semibold?: React.CSSProperties;
    h7Bold?: React.CSSProperties;
    h8?: React.CSSProperties;
    h8Semibold?: React.CSSProperties;
    h8Bold?: React.CSSProperties;
    h9?: React.CSSProperties;
    h9Semibold?: React.CSSProperties;
    h9Bold?: React.CSSProperties;
    h10?: React.CSSProperties;
    h10Semibold?: React.CSSProperties;
    h10Bold?: React.CSSProperties;
    h11?: React.CSSProperties;
    h11Semibold?: React.CSSProperties;
    h11Bold?: React.CSSProperties;
    h12?: React.CSSProperties;
    h12Semibold?: React.CSSProperties;
    h12Bold?: React.CSSProperties;
    h13?: React.CSSProperties;
  }

  interface BreakpointOverrides {
    xxl: true;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    h1Semibold: true;
    h1Bold: true;
    h2Semibold: true;
    h2Bold: true;
    h3Semibold: true;
    h3Bold: true;
    h4Semibold: true;
    h4Bold: true;
    h5Semibold: true;
    h5Bold: true;
    h6Semibold: true;
    h6Bold: true;
    h7: true;
    h7Semibold: true;
    h7Bold: true;
    h8: true;
    h8Semibold: true;
    h8Bold: true;
    h9: true;
    h9Semibold: true;
    h9Bold: true;
    h10: true;
    h10Semibold: true;
    h10Bold: true;
    h11: true;
    h11Semibold: true;
    h11Bold: true;
    h12: true;
    h12Semibold: true;
    h12Bold: true;
    h13: true;
  }
}

const FONT_STACK = "'Open Sans', sans-serif";

const theme = createTheme({
  typography: {
    fontFamily: FONT_STACK,
    allVariants: {
      fontFamily: FONT_STACK,
      letterSpacing: '0%',
      textDecoration: 'none',
      textTransform: 'none',
    },
    h1: {
      fontWeight: 'normal',
      fontSize: '36px',
      lineHeight: '125%',
    },
    h1Semibold: {
      fontWeight: 600,
      fontSize: '36px',
      lineHeight: '125%',
    },
    h1Bold: {
      fontWeight: 700,
      fontSize: '36px',
      lineHeight: '125%',
    },
    h2: {
      fontWeight: 'normal',
      fontSize: '34px',
      lineHeight: '125%',
    },
    h2Semibold: {
      fontWeight: 600,
      fontSize: '34px',
      lineHeight: '125%',
    },
    h2Bold: {
      fontWeight: 700,
      fontSize: '34px',
      lineHeight: '125%',
    },
    h3: {
      fontWeight: 'normal',
      fontSize: '32px',
      lineHeight: '125%',
    },
    h3Semibold: {
      fontWeight: 600,
      fontSize: '32px',
      lineHeight: '125%',
    },
    h3Bold: {
      fontWeight: 700,
      fontSize: '32px',
      lineHeight: '125%',
    },
    h4: {
      fontWeight: 'normal',
      fontSize: '30px',
      lineHeight: '125%',
    },
    h4Semibold: {
      fontWeight: 600,
      fontSize: '30px',
      lineHeight: '125%',
    },
    h4Bold: {
      fontWeight: 700,
      fontSize: '30px',
      lineHeight: '125%',
    },
    h5: {
      fontWeight: 'normal',
      fontSize: '28px',
      lineHeight: '150%',
    },
    h5Semibold: {
      fontWeight: 600,
      fontSize: '28px',
      lineHeight: '150%',
    },
    h5Bold: {
      fontWeight: 700,
      fontSize: '28px',
      lineHeight: '150%',
    },
    h6: {
      fontWeight: 'normal',
      fontSize: '24px',
      lineHeight: '150%',
    },
    h6Semibold: {
      fontWeight: 600,
      fontSize: '24px',
      lineHeight: '150%',
    },
    h6Bold: {
      fontWeight: 700,
      fontSize: '24px',
      lineHeight: '150%',
    },
    h7: {
      fontWeight: 'normal',
      fontSize: '22px',
      lineHeight: '150%',
    },
    h7Semibold: {
      fontWeight: 600,
      fontSize: '22px',
      lineHeight: '150%',
    },
    h7Bold: {
      fontWeight: 700,
      fontSize: '22px',
      lineHeight: '150%',
    },
    h8: {
      fontWeight: 'normal',
      fontSize: '20px',
      lineHeight: '150%',
    },
    h8Semibold: {
      fontWeight: 600,
      fontSize: '20px',
      lineHeight: '150%',
    },
    h8Bold: {
      fontWeight: 700,
      fontSize: '20px',
      lineHeight: '150%',
    },
    h9: {
      fontWeight: 'normal',
      fontSize: '18px',
      lineHeight: '150%',
    },
    h9Semibold: {
      fontWeight: 600,
      fontSize: '18px',
      lineHeight: '150%',
    },
    h9Bold: {
      fontWeight: 700,
      fontSize: '18px',
      lineHeight: '150%',
    },
    h10: {
      fontWeight: 'normal',
      fontSize: '16px',
      lineHeight: '150%',
    },
    h10Semibold: {
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '150%',
    },
    h10Bold: {
      fontWeight: 700,
      fontSize: '16px',
      lineHeight: '150%',
    },
    h11: {
      fontWeight: 'normal',
      fontSize: '14px',
      lineHeight: '125%',
    },
    h11Semibold: {
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '125%',
    },
    h11Bold: {
      fontWeight: 700,
      fontSize: '14px',
      lineHeight: '125%',
    },
    h12: {
      fontWeight: 'normal',
      fontSize: '12px',
      lineHeight: '125%',
    },
    h12Semibold: {
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '125%',
    },
    h12Bold: {
      fontWeight: 700,
      fontSize: '12px',
      lineHeight: '125%',
    },
    h13: {
      fontFamily: 'Inter',
      fontWeight: 'normal',
      fontSize: '10px',
      lineHeight: '125%',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1360,
      xl: 1536,
      xxl: 1920,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        'html, body, #root': {
          fontFamily: `${FONT_STACK} !important`,
        },
        'button, input, select, textarea, optgroup': {
          fontFamily: `${FONT_STACK} !important`,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: `${FONT_STACK} !important`,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: `${FONT_STACK} !important`,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: `${FONT_STACK} !important`,
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          fontFamily: `${FONT_STACK} !important`,
        },
        content: {
          fontFamily: `${FONT_STACK} !important`,
        },
      },
    },
  },
});

export default theme;
